export const DEFAULT_FINANCING_INTEREST = 11.5;
